<template>
  <el-table :data="roles" style="width: 100%" :default-expand-all="true">
    <el-table-column type="expand">
      <template slot-scope="scope">
        <template v-if="$i18n.locale == 'zh'">
          <el-tag
            style="margin-right: 8px"
            :key="permission.id"
            v-for="permission in scope.row.permissions"
            :disable-transitions="false">
            {{permission.name + '(' + permission.uri + ')'}}
          </el-tag>
        </template>
        <template v-else-if="$i18n.locale == 'en'">
          <el-tag
            style="margin-right: 8px"
            :key="permission.id"
            v-for="permission in scope.row.permissions"
            :disable-transitions="false">
            {{permission.enName + '(' + permission.uri + ')'}}
          </el-tag>
        </template>
      </template>
    </el-table-column>
    <el-table-column :label="generateCustomizeString('roleName')" prop="name" v-if="this.$i18n.locale == 'zh'">
    </el-table-column>
    <el-table-column :label="generateCustomizeString('roleName')" prop="enName" v-if="this.$i18n.locale == 'en'">
    </el-table-column>
    <el-table-column :label="generateCustomizeString('roleDescription')" prop="description" v-if="this.$i18n.locale == 'zh'">
    </el-table-column>
    <el-table-column :label="generateCustomizeString('roleDescription')" prop="enDescription" v-if="this.$i18n.locale == 'en'">
    </el-table-column>
  </el-table>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'RoleList',
  data() {
    return {
      loading: false,
      roles: []
    }
  },
  methods: {
    generateCustomizeString,
    fetchAllRolesPermissions() {
      if (this.loading) return
      this.loading = true
      request({
        url: 'permission/role/list',
        method: 'get',
        params: {
          permission: true
        }
      }).then(response => {
        this.roles = response.data
        for (var i = 0; i < this.roles.length; i++) {
          switch (this.roles[i].name) {
            case '订单管理员':
              this.roles[i].enName = this.generateCustomizeString('订单管理员')
              break
            case '商品管理员':
              this.roles[i].enName = this.generateCustomizeString('商品管理员')
              break
            case '仓储中心查询':
              this.roles[i].enName = this.generateCustomizeString('仓储中心查询')
              break
            case '内容管理':
              this.roles[i].enName = this.generateCustomizeString('内容管理')
              break
            case '店铺基础信息管理员':
              this.roles[i].enName = this.generateCustomizeString('店铺基础信息管理员')
              break
            case '会员管理员(无余额）':
              this.roles[i].enName = this.generateCustomizeString('会员管理员(无余额）')
              break
            case '店员权限管理':
              this.roles[i].enName = this.generateCustomizeString('店员权限管理')
              break
            case '订单查询':
              this.roles[i].enName = this.generateCustomizeString('订单查询')
              break
            case '物流管理员':
              this.roles[i].enName = this.generateCustomizeString('物流管理员')
              break
            case '代理管理':
              this.roles[i].enName = this.generateCustomizeString('代理管理')
              break
            case '优惠券管理':
              this.roles[i].enName = this.generateCustomizeString('优惠券管理')
              break
            case '会员管理员(余额）':
              this.roles[i].enName = this.generateCustomizeString('会员管理员(余额）')
              break
            case '交易查询':
              this.roles[i].enName = this.generateCustomizeString('交易查询')
              break
            default:
              this.roles[i].enName = this.roles[i].name
          }
        }
        for (var j = 0; j < this.roles.length; j++) {
          switch (this.roles[j].description) {
            case '管理订单、配货、发货、退款和查询功能':
              this.roles[j].enDescription = this.generateCustomizeString('管理订单、配货、发货、退款和查询功能')
              break
            case '管理品牌、商品分类、发货仓库、商品管理、入库管理。':
              this.roles[j].enDescription = this.generateCustomizeString('管理品牌、商品分类、发货仓库、商品管理、入库管理。')
              break
            case '查询商品出入库记录。':
              this.roles[j].enDescription = this.generateCustomizeString('查询商品出入库记录。')
              break
            case '店铺内容管理和banner管理。':
              this.roles[j].enDescription = this.generateCustomizeString('店铺内容管理和banner管理。')
              break
            case '管理店铺基础信息维护':
              this.roles[j].enDescription = this.generateCustomizeString('管理店铺基础信息维护')
              break
            case '管理会员等级、折扣方案、会员等级':
              this.roles[j].enDescription = this.generateCustomizeString('管理会员等级、折扣方案、会员等级')
              break
            case '添加店员，管理店员权限、查询角色权限':
              this.roles[j].enDescription = this.generateCustomizeString('添加店员，管理店员权限、查询角色权限')
              break
            case '只能看到已付款和已发货订单，并能编辑订单状态。':
              this.roles[j].enDescription = this.generateCustomizeString('只能看到已付款和已发货订单，并能编辑订单状态。')
              break
            case '管理物流公司、快递模板':
              this.roles[j].enDescription = this.generateCustomizeString('管理物流公司、快递模板')
              break
            case '添加代理和管理代理返佣':
              this.roles[j].enDescription = this.generateCustomizeString('添加代理和管理代理返佣')
              break
            case '优惠券管理':
              this.roles[j].enDescription = this.generateCustomizeString('优惠券管理')
              break
            case '编辑会员余额':
              this.roles[j].enDescription = this.generateCustomizeString('编辑会员余额')
              break
            case '交易查询.流水列表':
              this.roles[j].enDescription = this.generateCustomizeString('交易查询流水列表')
              break
            default:
              this.roles[j].enDescription = this.roles[j].description
          }
        }
        for (var m = 0; m < this.roles.length; m++) {
          for (var n = 0; n < this.roles[m].permissions.length; n++) {
            switch (this.roles[m].permissions[n].name) {
              case '订单列表':
                this.roles[m].permissions[n].enName = 'Order List'
                break
              case '商品中心.商品品牌':
                this.roles[m].permissions[n].enName = 'Merchandise.Brand'
                break
              case '商品中心.商品分类':
                this.roles[m].permissions[n].enName = 'Merchandise.Categories'
                break
              case '商品中心.发货仓库':
                this.roles[m].permissions[n].enName = 'Merchandise.Warehouse'
                break
              case '物流中心.快递公司.店铺配置列表':
                this.roles[m].permissions[n].enName = 'Express.Courier Company.list'
                break
              case '店铺管理.模板设置':
                this.roles[m].permissions[n].enName = 'Shop Management.Template'
                break
              case '商品中心.商品管理':
                this.roles[m].permissions[n].enName = 'Merchandise.Merchandise Management'
                break
              case '物流中心.快递模板.创建':
                this.roles[m].permissions[n].enName = 'Express.Template.Create'
                break
              case '物流中心.快递模板.删除':
                this.roles[m].permissions[n].enName = 'Express.Template.Delete'
                break
              case '物流中心.快递模板.更新':
                this.roles[m].permissions[n].enName = 'Express.Template.Update'
                break
              case '物流中心.快递模板列表':
                this.roles[m].permissions[n].enName = 'Express.Template List'
                break
              case '仓储中心.商品出入库记录':
                this.roles[m].permissions[n].enName = 'Stock.Operation Logs'
                break
              case '店铺管理.店铺设置.更新':
                this.roles[m].permissions[n].enName = 'Shop Management.Basic Information.Update'
                break
              case '会员中心.会员.列表':
                this.roles[m].permissions[n].enName = 'Member.Member List'
                break
              case '会员中心.会员.等级.编辑':
                this.roles[m].permissions[n].enName = 'Member.Member Level.Update'
                break
              case '会员中心.会员.详情':
                this.roles[m].permissions[n].enName = 'Member.Member Details'
                break
              case '会员中心.折扣方案.创建':
                this.roles[m].permissions[n].enName = 'Member.Discount Plans.Create'
                break
              case '会员中心.折扣方案.删除':
                this.roles[m].permissions[n].enName = 'Member.Discount Plans.Delete'
                break
              case '会员中心.折扣方案.更新':
                this.roles[m].permissions[n].enName = 'Member.Discount Plans.Update'
                break
              case '店员中心.店员管理.创建店员':
                this.roles[m].permissions[n].enName = 'Assistant.Create'
                break
              case '店员中心.店员管理.删除店员':
                this.roles[m].permissions[n].enName = 'Assistant.Delete'
                break
              case '店员中心.店员管理.店员.删除角色':
                this.roles[m].permissions[n].enName = 'Assistant.Role.Delete'
                break
              case '店员中心.店员管理.店员.赋予角色':
                this.roles[m].permissions[n].enName = 'Assistant.Role.Assign'
                break
              case '店员中心.店员管理.店员列表':
                this.roles[m].permissions[n].enName = 'Assistant.Assistant List'
                break
              case '物流中心.快递公司.删除':
                this.roles[m].permissions[n].enName = 'Express.Express Company.Delete'
                break
              case '物流中心.快递公司.添加':
                this.roles[m].permissions[n].enName = 'Express.Express Company.Create'
                break
              case '代理中心.代理商.列表':
                this.roles[m].permissions[n].enName = 'Agent.List'
                break
              case '代理中心.代理商.创建':
                this.roles[m].permissions[n].enName = 'Agent.Agent.Create'
                break
              case '代理中心.代理商.更新信息':
                this.roles[m].permissions[n].enName = 'Agent.Agent.Update'
                break
              case '会员中心.会员.余额.修改':
                this.roles[m].permissions[n].enName = 'Member.Credits.Update'
                break
              case '会员中心.会员.余额.修改.增量':
                this.roles[m].permissions[n].enName = 'Member.Credits.Update'
                break
              case '交易中心.流水记录':
                this.roles[m].permissions[n].enName = 'Transactions.List'
                break
              default:
                this.roles[m].permissions[n].enName = this.roles[m].permissions[n].name
            }
          }
        }
      }).catch(error => {
        console.warn(error)
      }).finally(() => {
        this.loading = false
      })
    }
  },
  created() {
    this.fetchAllRolesPermissions()
  }
}
</script>
